'use client';
import {
  Box,
  Grid2,
  Typography,
  Link as MuiLink,
  Skeleton,
} from '@mui/material';
import Link from 'next/link';
import EmptyContent from '../common/EmptyContent';
import { useAllBlogs } from '@/hooks/api/blog';
import BlogCard from './BlogCard';

const BlogSection = ({ username = null, blogs }) => {
  // if (isLoading)
  //   return (
  //     <>
  //       <Grid2 container columnSpacing={3} sx={{ mt: 5, width: '100%' }}>
  //         <Grid2 size={{ xs: 4 }}>
  //           <Skeleton variant="rectangular" width="100%" height={140} />
  //         </Grid2>
  //         <Grid2 size={{ xs: 4 }}>
  //           <Skeleton variant="rectangular" width="100%" height={140} />
  //         </Grid2>
  //         <Grid2 size={{ xs: 4 }}>
  //           <Skeleton variant="rectangular" width="100%" height={140} />
  //         </Grid2>
  //       </Grid2>
  //     </>
  //   );

  // if (isError) {
  //   return (
  //     <EmptyContent sx={{ height: '100%' }}>
  //       <Typography>خطایی رخ داده است</Typography>
  //     </EmptyContent>
  //   );
  // }
  if (blogs?.results.length > 0) {
    return (
      <Box>
        <Box sx={{ mt: 2 }}>
          <Grid2
            container
            gap={3}
            justifyContent={{
              xs: 'center',
              sm: 'center',
              md: blogs.totalResults > 2 ? 'center' : 'right',
            }}>
            {blogs.results?.map((item, index) => (
              <Grid2 key={index}>
                <BlogCard blog={item} blogType="public-blog" />
              </Grid2>
            ))}
          </Grid2>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          {blogs.totalResults > 2 && (
            <MuiLink
              component={Link}
              href={`/blogs?${username ? 'username=' + username : ''}`}
              variant="simpleLink">
              مشاهده بیشتر
            </MuiLink>
          )}
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ width: '100%', mx: 'auto' }}>
        <Typography sx={{ textAlign: 'center', my: 1 }}>
          مقاله ای ایجاد نشده است
        </Typography>
      </Box>
    );
  }
};

export default BlogSection;
